import React from "react";
import Image from "react-bootstrap/Image";
import toast from "react-hot-toast";

import "../styles/toast.scss";
import ImageCheckmark from "../images/checkmark-brand.svg";
import WarningIcon from "../components/icons/WarningIcon";

const showSuccessToast = (message: string, style?: React.CSSProperties) =>
  toast(message, {
    className: "hyper-toast",
    icon: <Image src={ImageCheckmark} alt="checkmark" />,
    style,
  });

const showErrorToast = (message: string, style?: React.CSSProperties) =>
  toast(message, {
    className: "hyper-toast",
    style,
  });

const showErrorToastDanger = (message: string, style?: React.CSSProperties) =>
  toast(message, {
    className: "hyper-toast error-toast",
    icon: <WarningIcon />,
    style,
  });

export { showSuccessToast, showErrorToast, showErrorToastDanger };
